/**
 * PURPOSE:
 * Renderizar un partido público compacto de la llave del evento 17.
 *
 * RESPONSIBILITIES:
 * - Mostrar enfrentamiento, código deportivo corto y marcador oficial.
 * - Omitir IDs, estados técnicos, published y número global del match.
 * - Delegar cada participante u origen pendiente al slot público.
 *
 * COLLABORATORS:
 * - Event17PublicBracket.jsx
 * - Event17PublicBracketSlot.jsx
 *
 * ROUTE:
 * src/components/Fixture/components/Event17PublicBracketMatch.jsx
 */
import React from "react";
import Event17PublicBracketSlot from "./Event17PublicBracketSlot";

function getMatchLabel(match) {
  if (match?.kind === "FINAL") return "Final";
  if (match?.kind === "THIRD") return "3.er puesto";
  return `M${match?.displayOrder || match?.position || ""}`;
}

export default function Event17PublicBracketMatch({
  match,
  moodName,
  emphasized = false,
}) {
  return (
    <article
      data-match-code={match?.code}
      className={`relative z-10 w-[232px] rounded-xl border bg-white p-2.5 transition ${
        emphasized
          ? "border-blue-200 shadow-md"
          : "border-slate-200 shadow-sm"
      }`}
    >
      <header className="mb-2 flex items-center justify-between gap-2 px-0.5">
        <span
          className={`text-xs font-bold ${
            emphasized ? "text-blue-700" : "text-slate-600"
          }`}
        >
          {getMatchLabel(match)}
        </span>
      </header>

      <div className="space-y-1.5">
        <Event17PublicBracketSlot slot={match?.slots?.[0]} moodName={moodName} />
        <Event17PublicBracketSlot slot={match?.slots?.[1]} moodName={moodName} />
      </div>

      {match?.isOfficial && match?.score && (
        <div className="mt-2 rounded-lg bg-slate-900 px-2.5 py-1.5 text-center text-xs font-bold text-white">
          {match.score}
        </div>
      )}
    </article>
  );
}
